/********************
  Created via mfCLI. Doc: https://marketfuel.getoutline.com/doc/mf-grid-cli-tool-mfcli-CQt1bFpg9u
  Grid Documentation: https://marketfuel.getoutline.com/doc/mf-grid-component-x54vV0bdDu
********************/
import MfGridFunctionalCoreConfig from '@components/general/mfgrid/MfGridFunctionalCoreConfig'
import { store } from '@src/redux/storeConfig/store'
import { Badge } from 'reactstrap'

export default function gridConfig(configOptions) {
  const gridUrl = `/mf/grid?table=cc_data_points`
  const dataKey = 'id'
  const idSortOrder = 'desc'
  const title = 'Custom Data Points'
  const titleNoSpace = title.replace(/\s+/g, '')
  const uniqueIdentifier = '9960b9b9a70ecefa2e788f49e180b8e8f2f6fa465f7572fe19f0aca4f72327c7'
  const permissions = 'CLIENT'
  const buttonsUrl = '/clientccdps'
  const showIds = store.getState().admins.current_admin.show_ids
  let sqlFields = configOptions.sqlFields || []
  const imageKeys = [] //  add the field name(s) to show the image(s): ['logo', 'image']
  if (sqlFields.length === 0) {
    sqlFields = sqlFields.length > 0 ? sqlFields.length : ['id', 'name']
  }

  const columns = [
    {
      allowEditing: false,
      allowHeaderFiltering: false,
      caption: 'ID',
      dataField: 'id',
      dataType: 'number',
      defaultSortOrder: idSortOrder,
      filterOperations: ['='],
      // minWidth: 50 // only use with for the necessary columns. In some cases, use minWidth
      visible: showIds,
      width: 60
    },
    {
      caption: 'Name',
      dataField: 'name',
      dataType: 'string',
      filterOperations: ['contains'],
      visible: true
      // width: 200,
    },
    // Add other columns here...
    {
      dataField: 'alias'
    }
    // {
    //   dataField: 'data_type'
    // },
    // {
    //   dataField: 'show_on_store',
    //   cellRender: ({ value }) => {
    //     return (
    //       <div className="is_active">
    //         {value ? <Badge color="success">YES</Badge> : <Badge color="warning">NO</Badge>}
    //       </div>
    //     )
    //   }
    // }
  ]

  configOptions['title'] = title
  configOptions['columns'] = columns
  configOptions['titleNoSpace'] = titleNoSpace

  'sqlFields' in configOptions ? delete configOptions.sqlFields : null // sqlFields is not needed in the configOptions object
  const coreConfig = MfGridFunctionalCoreConfig(configOptions)

  return {
    buttonsUrl: buttonsUrl.toLowerCase(),
    columns: coreConfig.columns,
    dataKey,
    filter: coreConfig.filter,
    gridUrl,
    idSortOrder,
    imageKeys: imageKeys ?? [],
    permissions,
    sqlFields,
    storageKey: uniqueIdentifier,
    title: configOptions.title,
    titleLowerCase: coreConfig.titleLowerCase,
    titleNoSpace,
    titleUpperCase: coreConfig.titleUpperCase
  }
}
